import { IRequestPaginationData } from '../../indigofair/data/IRequestPaginationData';

export namespace IListOrdersByBrandOrderRequest {
  export namespace ITab {
    export enum Enum {
      ENUM_UNKNOWN = 'ENUM_UNKNOWN',
      SHIPPED = 'SHIPPED',
      NOT_SHIPPED = 'NOT_SHIPPED',
      ACTION_REQUIRED = 'ACTION_REQUIRED',
    }

    /**
     * Return an instance of ITab with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<ITab>): ITab =>
      ({
        ...(partial ?? {}),
      }) as ITab;
  }

  export interface ITab {}

  /**
   * Return an instance of IListOrdersByBrandOrderRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IListOrdersByBrandOrderRequest>
  ): IListOrdersByBrandOrderRequest =>
    ({
      filter_keys: [],
      ...(partial ?? {}),
    }) as IListOrdersByBrandOrderRequest;
}

/**
 * This request will replace ListOrdersRequest. It will be more general, and will
 * divide up the response by shipment instead of by order.
 */
export interface IListOrdersByBrandOrderRequest {
  query: string | undefined;
  pagination_data: IRequestPaginationData | undefined;
  filter_keys: Array<string>;
  tab: keyof typeof IListOrdersByBrandOrderRequest.ITab.Enum | undefined;
  do_not_include_filters: boolean | undefined;
}
